<template>
    <div class="container-fluid">
        <section class="container-fluid">
            <h1 class="titles">Documento</h1>
            <h3 class="subtitles" v-if="pdf_name">{{ pdf_name }}.pdf</h3>
        </section>
        <section class="container-fluid">
            <b-overlay :show="finishLoading" rounded="sm" :opacity="0.5">
                <b-row>
                    <b-col xl="9">
                        <div class="pg_number">
                            {{ page }}/{{ numPages }}
                        </div>
                        <div ref="pdfComponent" class="viewer">
                            <div class="arrow left">
                                <b-icon icon="arrow-left-circle" font-scale="2" aria-hidden="true"
                                    @click="page > 1 ? page-- : 1"></b-icon>
                            </div>
                            <div class="arrow right">
                                <b-icon icon="arrow-right-circle" font-scale="2" aria-hidden="true"
                                    @click="page < numPages ? page++ : 1"></b-icon>
                            </div>
                            <vue-draggable-resizable
                                v-for="item in page > 0 ? pagesSignatures[page - 1].signaturesForShow : []"
                                :key="item.id" :w="item.imageWidth" :h="item.imageHeight" :x="item.xPosition"
                                :y="item.yPosition" :parent="true" :resizable="item.resize" :draggable="item.draggable"
                                @dragging="(x, y) => item.onDrag(x, y)"
                                @resizing="(x, y, width, height) => item.onResize(x, y, width, height)" :z="999">
                                <img :style="signatureStyleObject" v-if="item.img" ref="draggy" :src="item.img"
                                    :width="item.imageWidth" :height="item.imageHeight">
                            </vue-draggable-resizable>
                            <pdf :src="src" :page="page" class="pdf-self" @num-pages="numPages = $event"
                                @page-loaded="page = $event" @loaded="pdfLoaded" @progress="loadedRatio = $event"
                                @error="error">
                            </pdf>
                            <b-overlay :show="isLoading" opacity="0.5" blur="none" no-wrap>
                                <template v-slot:overlay>
                                    <div class="text-center">
                                        <b-icon icon="arrow-clockwise" class="mt-4 text-cid-primary" animation="spin"
                                            font-scale="3"></b-icon>
                                    </div>
                                </template>
                            </b-overlay>
                        </div>
                    </b-col>
                    <b-col xl="3" class="d-none d-xl-block p-0">
                        <b-container class="details-col px-2 py-4">

                            <h6 :class="{ titleUnderline: true }" v-if="sign_button && !isLoading">Acciones</h6>
                            <div class="border p-3" :class="{ 'mb-3': getTotalSignaturesCount() > 0 }"
                                v-if="showManualSignatureEditableItems()">
                                <div v-for="(pageObject, pageIndex) in pagesSignatures" :key="pageIndex">
                                    <div v-for="(signature, signatureIndex) in pageObject.signatures"
                                        :key="signature.id">
                                        <cid-button :class="{ 'mt-3': pageIndex > 0 || signatureIndex > 0 }"
                                            @click="removeSignature(pageIndex, signatureIndex)" class="px-4  w-100"
                                            block size="sm">
                                            Firma <b>{{ signatureIndex + 1 }}</b> en página:
                                            <b>{{ pageObject.pageNumber }}</b>
                                            <b-icon-trash-fill aria-hidden="true"></b-icon-trash-fill>
                                        </cid-button>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3 signButtonGrid" v-if="sign_button && !isLoading">

                                <cid-button v-b-tooltip.hover.v-info :title="signText" :disabled="!allowSignatures"
                                    class="px-4 " size="sm" @click="onFirmarBtnClick">
                                    <b-spinner v-if="!allowSignatures"></b-spinner>
                                    <b-icon-pen v-if="allowSignatures" aria-hidden="true" scale="2"></b-icon-pen>
                                    {{ getFirmarBtnText() }}
                                </cid-button>
                                <cid-button type="border" v-b-tooltip.hover.v-info :title="rejectText"
                                    @click="$bvModal.show('reject-document-modal');">
                                    <b-icon-file-break aria-hidden="true" scale="2"></b-icon-file-break> Rechazar
                                </cid-button>

                                <cid-button v-if="show_sign" v-b-tooltip.hover.v-info :title="saveText" size="sm"
                                    @click="saveLocation" class="px-4 ">
                                    <b-icon-check2-circle aria-hidden="true" class="iconBtn"></b-icon-check2-circle>
                                    Confirmar
                                </cid-button>

                            </div>
                            <h6 :class="{ marginButton: sign_button, titleUnderline: true }">Detalles del documento
                            </h6>
                            <div class="mt-3 mb-2">
                                <b-icon-file-earmark-text font-scale="1.3"
                                    variant="secondary"></b-icon-file-earmark-text><span class="ml-2 details-subtitle"
                                    v-if="pdf_name">{{ pdf_name }}.pdf</span>
                            </div>
                            <div class="mt-2 mb-1">
                                <span class="info-t">Creado el:</span>
                                <div class="info-d" v-if="pdf_created">
                                    {{ new Date(pdf_created) | date('dd/MM/yyyy') }}
                                </div>
                            </div>
                            <div class="mt-2 mb-1">
                                <span class="info-t">Estado:</span>
                                <div class="info-d" v-if="pdf_created">
                                    {{ state }}
                                </div>
                            </div>
                            <div class="mt-2 mb-1" v-if="show_hash">
                                <span class="info-t">Hash:</span>
                                <div class="info-d"> {{ hash }}</div>
                            </div>
                            <hr class="my-1" />
                            <b-container>
                                <b-row class="justify-content-center">
                                    <b-col xl="8" class="text-center mt-2">
                                        <div style="font-size: 2rem;">
                                            <b-icon-arrow-left id="back" aria-hidden="true" class="action-details-btn"
                                                scale="0.6" @click="backToList"></b-icon-arrow-left>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>

                        </b-container>
                        <b-modal id="signatureOptions" centered no-close-on-backdrop hide-footer size="lg">
                            <template #modal-title>
                                <h4>Firmar documento</h4>
                            </template>
                            <b-row>
                                <b-col class="text-left text-lg-center mb-4">
                                    <p class="custom-subtitle h6">
                                        Escoja un método de firma:
                                    </p>
                                </b-col>
                            </b-row>
                            <b-row class="justify-content-center">
                                <b-col class="text-center border-right" lg="4">
                                    <div class="text-left text-lg-center">
                                        <b-img :src="require('../../assets/mobile-option.png')"
                                            class="sign-image"></b-img>
                                    </div>
                                    <div class="d-lg-none text-left">
                                        <b-row class="mb-3">
                                            <b-col cols="9">
                                                <h6>Dispositivo móvil</h6>
                                                <p class="custom-subtitle pt-0 mb-1">
                                                    Puedes utilizar tu dispositivo móvil o computadora, mientras firmas
                                                    en
                                                    la
                                                    pantalla táctil o usando mouse se capturará tu rostro como
                                                    evidencia.
                                                </p>
                                            </b-col>
                                            <b-col cols="3" class="text-right">
                                                <div style="font-size:1.8rem">
                                                    <b-icon-arrow-right-short aria-hidden="true"
                                                        @click="showModalSignatureBio" class="sign-option-btn"
                                                        scale="1"></b-icon-arrow-right-short>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <hr class="my-1" />
                                    </div>
                                </b-col>
                                <!--oculto with d-none -->
                                <b-col class="text-center border-right" lg="4" v-if="!disabledOption2S">
                                    <div class="text-left text-lg-center mt-2 mt-xl-0">
                                        <b-img :src="require('../../assets/sign-option.png')"
                                            class="sign-image"></b-img>
                                    </div>
                                    <div class="d-lg-none text-left">
                                        <b-row class="mb-3">
                                            <b-col cols="9">
                                                <h6>Firma electrónica certificada</h6>
                                                <p class="custom-subtitle pt-0 mb-1">
                                                    Si dispone de certificado electrónico calificado puede usar esta
                                                    opción.
                                                </p>
                                            </b-col>
                                            <b-col cols="3" class="text-right">
                                                <div style="font-size:1.8rem">
                                                    <b-icon-arrow-right-short aria-hidden="true"
                                                        @click="openDigitalCertificate" class="sign-option-btn"
                                                        scale="1"></b-icon-arrow-right-short>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <hr class="my-1" />
                                    </div>
                                </b-col>
                                <b-col class="text-center" lg="4">
                                    <div class="text-left text-lg-center mt-2 mt-xl-0">
                                        <b-img :src="require('../../assets/otp-option.png')" class="sign-image"></b-img>
                                    </div>
                                    <div class="d-lg-none text-left">
                                        <b-row class="mb-3">
                                            <b-col cols="9">
                                                <h6>Código OTP</h6>
                                                <p class="custom-subtitle pt-0 mb-1">
                                                    Recibirá un sms a su número de teléfono móvil con un código de
                                                    verificación.
                                                </p>
                                            </b-col>
                                            <b-col cols="3" class="text-right">
                                                <div style="font-size:1.8rem">
                                                    <b-icon-arrow-right-short aria-hidden="true" @click="showModalOTP"
                                                        class="sign-option-btn" scale="1"></b-icon-arrow-right-short>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="justify-content-center">
                                <b-col class="text-center border-right d-none d-lg-block" md="4">
                                    <h6>Dispositivo móvil</h6>
                                    <p class="custom-subtitle pt-0 mb-1 px-2">
                                        Utilizará su dispositivo móvil,haciendo una captura de su rostro mientras firma
                                        en
                                        la
                                        pantalla táctil.
                                    </p>
                                </b-col>
                                <!--oculto d-none -->
                                <b-col class="text-center border-right d-none d-lg-block" md="4"
                                    v-if="!disabledOption2S">
                                    <h6>Firma electrónica certificada</h6>
                                    <p class="custom-subtitle pt-0 mb-1 px-4">
                                        Si dispone de certificado electrónico calificado puede usar esta opción.
                                    </p>
                                </b-col>
                                <b-col class="text-center d-none d-none d-lg-block" md="4">
                                    <h6>Código OTP</h6>
                                    <p class="custom-subtitle pt-0 mb-1 px-4">
                                        Recibirá un sms a su número de teléfono móvil con un código de verificación.
                                    </p>
                                </b-col>
                            </b-row>
                            <b-row class="justify-content-center">
                                <b-col class="text-center border-right d-none d-lg-block" md="4">
                                    <div style="font-size:1.8rem">
                                        <b-icon-arrow-right-short aria-hidden="true" @click="showModalSignatureBio"
                                            class="sign-option-btn" scale="1"></b-icon-arrow-right-short>
                                    </div>
                                </b-col>
                                <!--oculto -->
                                <b-col class="text-center border-right d-none d-lg-block" md="4"
                                    v-if="!disabledOption2S">
                                    <div style="font-size:1.8rem">
                                        <b-icon-arrow-right-short aria-hidden="true" @click="openDigitalCertificate"
                                            class="sign-option-btn" scale="1"></b-icon-arrow-right-short>
                                    </div>
                                </b-col>
                                <b-col class="text-center d-none d-lg-block" md="4">
                                    <div style="font-size:1.8rem">
                                        <b-icon-arrow-right-short aria-hidden="true" @click="showModalOTP"
                                            class="sign-option-btn" scale="1"></b-icon-arrow-right-short>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-tooltip target="bio_signbtn" variant="info">
                                Firma de manera automática en tu dispositivo y capturará tu reconocimiento facial como
                                seguridad
                                de autenticidad
                            </b-tooltip>
                            <b-tooltip target="dig_signbtn" variant="info">
                                Firma otorgada a través del Registro Público. Si deseas obtenerla ingresa en
                                https://www.firmaelectronica.gob.pa.
                            </b-tooltip>
                            <b-tooltip target="otp_signbtn" variant="info">
                                Si no cuenta con acceso a cámara en tu dispositivo obtendrás un código en tu Whatsapp
                                para
                                validar tu identidad.
                            </b-tooltip>
                        </b-modal>
                        <b-modal id="signatureOTP" centered no-close-on-backdrop hide-footer>
                            <template #modal-title>
                                <h4>Firmar documento con código OTP</h4>
                            </template>
                            <b-row class="px-4">
                                <b-col>
                                    <p class="custom-subtitle">
                                        Haga click en el botón de "Obtener Código", y a continuación recibirá
                                        un SMS con el código de verificación al número de teléfono que tiene registrado
                                        en
                                        el
                                        sistema.
                                    </p>
                                </b-col>
                            </b-row>
                            <b-row class="px-4 mt-2">
                                <b-col class="d-flex">
                                    <div>
                                        <cid-button class="px-4 " size="sm" @click="sendOTP">
                                            Obtener código
                                        </cid-button>
                                    </div>
                                    <div class="flex-fill">
                                        <b-form-input placeholder="Introducir código" v-model="codeOTP"
                                            class="w-100 input-rounded" size="sm"></b-form-input>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="mt-4 pr-3">
                                <b-col class="text-right">
                                    <cid-button class="" size="sm" @click="verifyOTP">
                                        Aceptar
                                    </cid-button>
                                </b-col>
                            </b-row>
                        </b-modal>
                        <b-modal id="signatureBio" centered no-close-on-backdrop hide-footer>
                            <template #modal-header="">
                                <h4>Nueva firma</h4>
                                <b-btn-close size="sm" @click="onCanceleSignatureBio()">
                                </b-btn-close>
                            </template>
                            <b-row class="px-md-4" v-if="VerifySignerOption">
                                <b-col>
                                    <b-alert show fade variant="info">
                                        <h5 class="alert-heading text-center mb-0">
                                            {{ action }}
                                            <b-icon icon="emoji-smile" v-if="!smile_step"></b-icon>
                                            <b-icon icon="emoji-neutral" v-if="smile_step && !neutral_step"></b-icon>
                                            <b-icon icon="person-check" v-if="neutral_step && smile_step"></b-icon>
                                        </h5>
                                    </b-alert>
                                </b-col>
                            </b-row>


                            <b-overlay :show="ValidateTELoading" rounded="sm">
                                <b-row class="px-md-4 mt-2">
                                    <b-col>
                                        <canvas ref="canvas" width="320" height="240" style="display: none"
                                            v-show="isPhotoTaken" id="photoTaken">
                                        </canvas>
                                        <div class="webcam-container">
                                            <video id="video" ref="camera" autoplay playsinline @play="onPlay"
                                                class="topinfo">
                                            </video>
                                            <br />
                                            <canvas id="canv" v-if="!isValidFace"></canvas>
                                        </div>
                                    </b-col>
                                </b-row>
                                <template v-slot:overlay>
                                    <div class="d-flex justify-content-center">
                                        <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
                                        <p id="cancel-label">Validando Identidad...</p>
                                    </div>
                                </template>
                            </b-overlay>

                            <div v-if="isValidFace">
                                <b-row class="px-md-4">
                                    <b-col>
                                        <VueSignaturePad :options="{ onBegin, minWidth: 2 }" ref="signaturePad"
                                            id="signaturePad" width="inherit" height="220px" />
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4 mb-3 justify-content-around">
                                    <cid-button class="text-center sign-btn bg-white-btn py-2 px-4" @click="undoSign">
                                        Repetir
                                    </cid-button>
                                    <cid-button class=" text-center py-2 px-4" @click="saveSign"
                                        :disabled="!this.isValidFace">
                                        Aceptar
                                    </cid-button>
                                </b-row>
                            </div>
                        </b-modal>
                    </b-col>
                </b-row>
                <b-row class="d-xl-none ml-xl-2 mx-0 mt-2 justify-content-center bg-white">
                    <div class="pt-3 pb-3" v-if="showManualSignatureEditableItems()">
                        <div v-for="(pageObject, pageIndex) in pagesSignatures" :key="pageIndex">
                            <div v-for="(signature, signatureIndex) in pageObject.signatures" :key="signature.id">
                                <cid-button :class="{ 'mt-3': pageIndex > 0 || signatureIndex > 0 }"
                                    @click="removeSignature(pageIndex, signatureIndex)" class="px-4  w-100" block
                                    size="sm">
                                    Firma <b>{{ signatureIndex + 1 }}</b> en página: <b>{{ pageObject.pageNumber }}</b>
                                    <b-icon-trash-fill aria-hidden="true"></b-icon-trash-fill>
                                </cid-button>
                            </div>
                        </div>
                    </div>
                </b-row>

                <b-overlay v-if="sign_button" :show="docDetailsLoading" rounded="sm">
                    <b-row class="d-xl-none ml-xl-2 mx-0 my-2">
                        <b-col cols="12" class="bg-white pt-4 pb-2 d-flex justify-content-around">
                            <cid-button v-b-tooltip.hover.v-info :title="signText" size="lg" class="px-4 "
                                :disabled="!allowSignatures" @click="onFirmarBtnClick">
                                <b-spinner v-if="!allowSignatures" small></b-spinner>
                                <b-icon-pen v-if="allowSignatures" aria-hidden="true"></b-icon-pen>
                                {{ getFirmarBtnText() }}
                            </cid-button>
                            <cid-button type="border" v-b-tooltip.hover.v-info :title="rejectText"
                                @click="$bvModal.show('reject-document-modal');">
                                <b-icon-file-break aria-hidden="true"></b-icon-file-break> Rechazar
                            </cid-button>
                        </b-col>
                        <b-col cols="12" class="bg-white pb-2">
                            <div v-if="show_sign">
                                <cid-button v-b-tooltip.hover.v-info :title="saveText" size="lg" block class="px-4 "
                                    @click="saveLocation">
                                    <b-icon-check2-circle aria-hidden="true"></b-icon-check2-circle> Confirmar
                                </cid-button>
                            </div>
                        </b-col>
                    </b-row>
                    <template v-slot:overlay>
                        <div class="text-center">
                            <b-icon icon="arrow-clockwise" class="mt-4 text-cid-primary" animation="spin"
                                font-scale="3"></b-icon>
                        </div>
                    </template>
                </b-overlay>
                <template v-slot:overlay>
                    <div class="text-center">
                        <b-icon icon="arrow-clockwise" class="mt-4 text-cid-primary" animation="spin"
                            font-scale="3"></b-icon>
                        <p id="cancel-label">Por favor espere...</p>
                    </div>
                </template>
            </b-overlay>
        </section>

        <b-sidebar id="sidebar-details" title="" right bg-variant="white" backdrop shadow class="d-xl-none">
            <template #footer>
                <hr class="my-1 mx-3" />
                <b-row class="justify-content-center">
                    <b-col xl="8" class="text-center mt-2 pb-3">
                        <div style="font-size: 2rem;">
                            <b-icon-arrow-left id="back" aria-hidden="true" class="action-details-btn" scale="0.6"
                                @click="backToList"></b-icon-arrow-left>
                        </div>
                    </b-col>
                </b-row>
            </template>
            <div class="px-3 mb-4">
                <h6 :class="{ marginButton: sign_button, titleUnderline: true }">Detalles del documento</h6>
                <div class="mt-3 mb-2">
                    <b-icon-file-earmark-text font-scale="1.3" variant="secondary"></b-icon-file-earmark-text><span
                        class="ml-2 details-subtitle" v-if="pdf_name">{{ pdf_name }}.pdf</span>
                </div>
                <div class="mt-2 mb-1">
                    <span class="info-t">Creado el:</span>
                    <div class="info-d" v-if="pdf_created">
                        {{ new Date(pdf_created) | date('dd/MM/yyyy') }}
                    </div>
                </div>
                <div class="mt-2 mb-1">
                    <span class="info-t">Estado:</span>
                    <div class="info-d" v-if="pdf_created">
                        {{ state }}
                    </div>
                </div>
                <div class="mt-2 mb-1" v-if="show_hash">
                    <span class="info-t">Hash:</span>
                    <div class="info-d"> {{ hash }}</div>
                </div>
            </div>
        </b-sidebar>
        <b-modal id="document-pending-modal" centered no-close-on-backdrop hide-footer hide-header-close>
            <template #modal-title>
                <h4>Documento pendiente de firmar</h4>
            </template>
            <b-row class="px-4">
                <b-col>
                    <h6>¡Saludos!</h6>
                    <p class="custom-subtitle">
                        Le han enviado un documento para ser firmado de manera digital. Estaremos capturando las
                        evidencias que confirman que eres el firmante, al mismo tiempo está dando su consentimiento para
                        ello. Utilizaremos su cámara para este fin, la cual capturará diferentes fotos mientras firmas
                        digitalmente únicamente.
                    </p>
                    <p class="custom-subtitle">
                        Esta información sólo podrá ser utilizada por las partes que firman, o por la persona que le ha
                        enviado este documento, de conformidad a las Leyes locales.
                    </p>
                    <p class="custom-subtitle">
                        Ahora, puede usted iniciar la firma haciendo click en “Firmar”, podrás realizarlo con el mouse o
                        con la pantalla táctil de tu dispositivo.
                    </p>
                </b-col>
            </b-row>
            <b-row class="mt-4 mb-2 pr-4">
                <b-col class="text-right">
                    <cid-button @click="askData">Aceptar</cid-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal id="data-pending-modal" centered no-close-on-backdrop hide-footer>
            <template #modal-title>
                <h4>Introduzca los datos solicitados</h4>
            </template>
            <b-row class="px-2">
                <b-col md="6">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group>
                            <label class="receiver-subtitle">Nombre</label>
                            <b-form-input v-model="askedUserData.name" class="input-rounded" size="sm"></b-form-input>
                            <span class="subtitle-error" v-if="errors.length > 0">{{ errors[0] }}</span>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group>
                            <label class="receiver-subtitle">Apellidos</label>
                            <b-form-input v-model="askedUserData.lastName" class="input-rounded"
                                size="sm"></b-form-input>
                            <span class="subtitle-error" v-if="errors.length > 0">{{ errors[0] }}</span>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col class="pr-md-0" md="12">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group>
                            <label class="receiver-subtitle">Identificación</label>
                            <b-form-input v-model="askedUserData.documentId" class="input-rounded"
                                size="sm"></b-form-input>
                            <span class="subtitle-error" v-if="errors.length > 0">{{ errors[0] }}</span>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="text-right pt-3 pb-2 px-3">
                <cid-button class=" px-5"
                    :disabled="this.askedUserData.documentId == null || this.askedUserData.lastName == null || this.askedUserData.name == null"
                    @click="saveAskedData()" size="sm">
                    Aceptar
                </cid-button>
            </div>
        </b-modal>
        <b-modal id="reject-document-modal" centered no-close-on-backdrop hide-footer>
            <template #modal-title>
                <h4>Rechazar documento</h4>
            </template>
            <b-row class="px-4">
                <b-col>
                    <p class="mb-0 custom-subtitle">
                        Introduzca en no más de 100 caracteres el motivo de rechazo
                    </p>
                </b-col>
            </b-row>
            <b-row class="mt-2 px-4">
                <b-col>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group class="mb-0">
                            <b-form-textarea v-model="rejectDocumentDetails"
                                :state="rejectDocumentDetails.length <= 100" rows="3">
                            </b-form-textarea>
                            <span class="subtitle-error">{{ errors[0] }}</span>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="row mb-3 px-4">
                <div class="col text-right">
                    <cid-button class="px-5 " size="sm" @click="saveRejectDocument"
                        :disabled="this.rejectDocumentDetails == '' || this.rejectDocumentDetails.length > 100">
                        Aceptar
                    </cid-button>
                </div>
            </div>
        </b-modal>
        <b-modal id="generated-signature-modal" centered no-close-on-backdrop hide-footer hide-header>
            <b-row class="mt-3 text-center">
                <b-col>
                    <b-icon-check-circle class="check-icon"></b-icon-check-circle>
                    <h4 class="mt-2">Firma agregada correctamente</h4>
                    <h6 class="doc-info-subtitle"> Gracias por firmar con ConfidenceID</h6>
                </b-col>
            </b-row>
            <b-row class="text-center mt-2">
                <b-col>
                    <p v-if="this.fillSignaturePositionsWithServerValues" class="doc-info-subtitle mt-2">
                        Verifique que la firma aparezca en el documeto y posteriormente, hacer click
                        en “<b font-scale="2">Confirmar</b>” para finalizar el firmado del documento.
                    </p>
                    <p v-if="!this.fillSignaturePositionsWithServerValues" class="doc-info-subtitle mt-2">
                        Ahora puedes <b>mover la firma</b> al lugar que desees del mismo,
                        y posteriormente, hacer click en “<b font-scale="2">Confirmar</b>” para finalizar el firmado del
                        documento..
                    </p>
                </b-col>
            </b-row>
            <div class="row text-center mb-2">
                <div class="col-sm mt-1">
                    <cid-button class="px-5 " size="sm" @click="$bvModal.hide('generated-signature-modal')">
                        Aceptar
                    </cid-button>
                </div>
            </div>
        </b-modal>
        <b-modal id="save-signature-modal" centered no-close-on-backdrop hide-footer hide-header>
            <b-row class="mt-3 text-center">
                <b-col>
                    <b-icon-check-circle class="check-icon"></b-icon-check-circle>
                    <h4 class="mt-2">Documento firmado correctamente</h4>
                    <h6 class="doc-info-subtitle"> Gracias por firmar con ConfidenceID</h6>
                </b-col>
            </b-row>
            <b-row class="px-1 px-md-5">
                <b-col class="text-center">
                    <p class="custom-subtitle">
                        Puede realizar una descarga o imprimir el documento en este momento, o más tarde recibirá una
                        copia
                        en su dirección de correo electrónico, cuando hayan completado todos los firmantes.
                    </p>
                </b-col>
            </b-row>
            <div class="row text-center mb-5 d-block d-sm-none">
                <div class="col-sm mt-1">
                    <cid-button class="px-4 sign-btn bg-white-btn" size="sm" @click="downloadPdf">
                        <b-icon-file-earmark-arrow-down aria-hidden="true"
                            variant="danger"></b-icon-file-earmark-arrow-down>
                        <span>Descargar</span>
                    </cid-button>
                </div>
            </div>
            <div class="row text-center mb-3">
                <div class="col-sm mt-1">
                    <cid-button class="px-5 " size="sm" @click="onSaveSignature">
                        Aceptar
                    </cid-button>
                </div>
            </div>
        </b-modal>
        <b-modal id="sendOTP-success-modal" centered no-close-on-backdrop hide-footer hide-header>
            <b-row class="mt-3 text-center">
                <b-col>
                    <b-icon-check-circle class="check-icon"></b-icon-check-circle>
                    <h4 class="mt-2">Código OTP enviado correctamente</h4>
                </b-col>
            </b-row>
            <div class="row text-center mb-3">
                <div class="col-sm mt-1">
                    <cid-button name="sendOtpCode" class="px-5 " size="sm" @click="onSendOtpCode">
                        Aceptar
                    </cid-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
import pdf from 'vue-pdf'
//import * as faceapi from 'face-api.js'
import Human from "@vladmandic/human";
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { speakMessage } from '../voice/index.js'
export default {
    name: 'viewerDoc',
    components: {
        pdf,
    },
    data() {
        return {
            pagesSignatures: [],
            incrementalSignatureId: 0,
            signatureStyleObject: {
                opacity: 0.85,
            },
            userFileSignaturePositions: [],
            fillSignaturePositionsWithServerValues: false,
            allowSignatures: false,

            src: '',
            numPages: undefined,
            pdf_id: this.$route.params.id,
            pdf_name: null,
            signed: null,
            pdf_created: null,
            page: 0,
            publicPath: process.env.BASE_URL,
            img: null,
            signature_pad: undefined,
            hash: null,
            senders: [],
            pendingSenders: [],
            state: null,
            //sign details
            userSent: null,
            userSign: null,
            userEmailSign: null,
            sentDate: null,
            signDate: null,
            //show images captured
            user_captured: [],
            //get parameters
            name: null,
            email: null,
            security_id: null,
            width: 0,
            height: 0,
            pageWidth: 0,
            pageHeight: 0,
            x: 0,
            y: 0,
            image: false,
            isLoading: false,
            docDetailsLoading: true,
            folder_name: null,
            dateReception: null,
            reminderLoading: false,
            // Camera
            isPhotoTaken: false,
            image_captured: [],
            print: false,
            show_sign: false,
            sign_button: this.$store.getters.loggedIn,
            show_hash: false,
            current_email: this.$store.state.userEmail,
            evidenceLoading: false,
            finishLoading: false,
            userName: null,
            selected_signed_user: null,
            // Save Signature
            recipient_name: null,
            recipient_email: null,
            token: null,
            codeOTP: null,
            loadedRatio: 0,
            notifications: false,
            ask_data: false,
            askedUserData: [
                {
                    name: null,
                    lastName: null,
                    documentId: null
                }
            ],
            rejectDocumentDetails: '',
            action: "Por favor mire en dirección a la cámara y siga las instrucciones",
            neutral_step: false,
            smile_step: false,
            isValidFace: false,
            human: null,
            humanConfig: null,
            timestamp: null,
            fps: null,
            detectionGestures: true,

            //disable second option for sing
            disabledOption2S: true,
            cedula: "",
            ValidateTELoading: false,
            loading: false,
            face: null,
            drawTimer: null,
            intervalTimer: null,
            circleColor: "#FF0000",
            greenTimer: 0,
            isInsideCircle: false,
            isGreen: this.circleColor == "00ff00",
            canvas: null,
            video: null,
            SignatureOption: null,
            VerifySignerOption: null,
            FirmarBtnText: null,
            signText: "Utiliza esta opción para firmar y previsualizar la misma en el documento.",
            addsignText: "Utiliza esta opción añadir una nueva firma y previsualizar la misma en el documento en donde tu desees.",
            againsignText: "Utiliza esta opción para eliminar la previsualizacion previa y volver a crear otra.",
            saveText: "Utiliza esta opción para guardar el documento con los cambios realizados y finalizar el proceso de firma.",
            rejectText: " Si no estás de acuerdo con el contenido o la validez del documento, puedes utilizar esta opción para rechazar su firma. ¡Asegúrate de revisar cuidadosamente antes de rechazar!",
        }
    },
    watch: {
        page() {
            this.watchRenderPage();
        },
        FirmarBtnText() {
            const firmarBtnText = this.getFirmarBtnText();

            if (firmarBtnText === 'Añadir') {
                this.signText = this.addsignText;
            } else if (firmarBtnText === 'Volver a firmar') {
                this.signText = this.againsignText;
            } else {
                this.signText = 'Utiliza esta opción para firmar y previsualizar la misma en el documento.';
            }
        }
    },
    computed: {
        allowSpeech() {
            return this.$store.getters.getSpeackingState;
        }
    },
    created() {
        let self = this;
        self.src = pdf.createLoadingTask('/api/File/' + this.pdf_id);
    },
    async mounted() {
        if (this.$route.params.secure) {
            localStorage.clear();
        }
        if (!this.$store.getters.loggedIn) {
            axios.get('/api/File/GetUserByFileId/' + this.pdf_id).then(response => {
                if (response.data.IsSuccessFul) {
                    this.userName = response.data.Result.Username;
                }
            });
        } else {
            this.userName = this.$store.state.userName
        }
        this.getFileDetail();
        this.getUserDateReception();

        let self = this;
        self.src.promise.then((pdf) => {

            this.numPages = pdf.numPages;
            this.isLoading = false;

            for (let i = 0; i < this.numPages; i++) {
                let data = {
                    pageNumber: i + 1,
                    pageWidth: 0,
                    pageHeight: 0,
                    signatures: [],
                    signaturesForShow: []
                };
                this.pagesSignatures.push(data);
            }


        });

        this.token = localStorage.getItem('access_token');

        await this.$store.dispatch("load");

        axios.get('/api/File/GetUserByFileId/' + this.pdf_id).then(response => {
            if (response.data.IsSuccessFul) {
                this.cedula = response.data.Result.Dni;
            }
        });
    },
    methods: {
        showManualSignatureEditableItems() {
            return this.getTotalSignaturesCount() > 0 && this.fillSignaturePositionsWithServerValues == false;
        },
        getFirmarBtnText() {
            let text = "";
            if (this.fillSignaturePositionsWithServerValues) {
                text = this.getTotalSignaturesCount() > 0 ? 'Volver a firmar' : 'Firmar';
                this.FirmarBtnText = text;
            } else {
                text = this.getTotalSignaturesCount() > 0 ? 'Añadir' : 'Firmar';
                this.FirmarBtnText = text;
            }
            return text;
        },
        onFirmarBtnClick() {
            let speakTextRemoveSignature = "Se ha eliminado la firma de la previsualizacion.";
            let speakTextAddSignature = "Se ha añadido la firma a la previsualizacion.";
            if (!this.allowSignatures) { // race condition
                return;
            }

            if (this.fillSignaturePositionsWithServerValues) {
                if (this.getTotalSignaturesCount() > 0) {
                    // Remove signatures
                    this.playAudio(speakTextRemoveSignature);
                    this.show_sign = false;
                    this.pagesSignatures.forEach((pageObject) => {
                        pageObject.signatures = [];
                        pageObject.signaturesForShow = [];
                    });

                } else {
                    this.showModalSignatureOptions(this.SignatureOption);
                }
            } else {
                if (this.getTotalSignaturesCount() > 0) {
                    this.playAudio(speakTextAddSignature);
                    this.addSignatureToPage();
                } else {
                    this.showModalSignatureOptions(this.SignatureOption);
                }
            }
        },
        getTotalSignaturesCount() {
            if (this.page == 0)
                return 0;

            return this.pagesSignatures.reduce((total, element) => total + element.signatures.length, 0);
        },
        removeSignature(pageIndex, signatureIndex) {
            let speakTextRemoveSignature = "Se ha eliminado la firma de la previsualizacion.";

            this.playAudio(speakTextRemoveSignature);
            let pageObject = this.pagesSignatures[pageIndex];
            pageObject.signatures.splice(signatureIndex, 1);
            pageObject.signaturesForShow = pageObject.signatures.slice();

        },
        onBegin() {
            this.$refs.signaturePad.resizeCanvas();
            setTimeout(() => {
                if (this.image_captured.length < 3) {
                    this.takePhoto();
                }
            }, 1000);
        },
        getUserDateReception() {

            let email = null;
            if (this.$store.getters.loggedIn) {
                email = this.current_email;
            } else {
                email = this.$route.params.email
            }
            if (localStorage.tab_title == "Pendientes" || this.$route.params.secure != null) {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
                axios.get('/api/File/UpdateDocDateReception/' + this.pdf_id + '/' + email).then(() => { });
            }
        },
        getFileDetail() {
            this.isLoading = true;
            if (this.$route.params.user && this.$route.params.user != "Multifirma") {
                this.name = this.$route.params.user;
            }
            if (this.$route.params.email) {
                this.email = this.$route.params.email;
            }
            if (this.$route.params.secure) {
                this.sign_button = true;
                this.security_id = this.$route.params.secure;
                this.$store.dispatch("destroyToken").then(() => { });
            }
            if (this.$store.getters.loggedIn) {
                this.email = this.current_email;
            }

            if (localStorage.tab_title == "En proceso" ||
                localStorage.tab_title == "Completado" ||
                !this.$store.getters.loggedIn && this.state == 'Completado') {
                this.sign_button = false;
                this.docDetailsLoading = false;
            }

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
            axios.get('/api/File/GetFileById/' + this.pdf_id + '/' + this.name + '/' + this.email + '/' + this.security_id).then(response => {
                if (response.data.IsSuccessFul) {
                    this.docDetailsLoading = false;
                    this.pdf_name = response.data.Result.DocumentName;
                    this.folder_name = response.data.Result.FolderName;
                    this.signed = response.data.Result.Signed;
                    this.state = response.data.Result.State;
                    this.ask_data = response.data.Result.AskData;
                    this.pdf_created = response.data.Result.Created;
                    this.hash = response.data.Result.HashSignature;
                    this.senders = response.data.Result.EmailList;
                    this.pendingSenders = this.senders.filter(sender => {
                        return sender.State == "Completado";
                    })
                    this.notifications = response.data.Result.Notifications;
                    this.sign_button = response.data.Result.SignButton;
                    this.userFileSignaturePositions = response.data.Result.UserFileSignaturePositions;
                    this.fillSignaturePositionsWithServerValues = this.userFileSignaturePositions.length > 0;
                    this.SignatureOption = response.data.Result.SignatureOption;
                    this.VerifySignerOption = response.data.Result.verifySigner;

                    if (this.state == "Pendiente" || this.state == "Progreso") {
                        this.$bvModal.show('document-pending-modal');
                    }

                    if (this.state == "Completado") {
                        this.show_hash = true;
                    }
                    if (this.signed || this.state === "Rechazado") {
                        this.sign_button = false;
                    }
                } else {
                    this.$bvToast.toast(`El acceso a este archivo no esta permitido, revise la url.`, {
                        title: 'Lo sentimos',
                        variant: 'danger'
                    });
                }
            });
        },
        printPdf() {
            let config = { responseType: 'blob' }
            this.print = true;
            axios.get('/api/File/GetFilePrint/' + this.pdf_id + '/' + this.print + '/' + this.email, config).then(response => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                this.$print(fileURL);
                this.print = false;
            });
        },
        downloadPdf() {
            window.open('/api/File/GetFilePrint/' + this.pdf_id + '/' + this.print + '/' + this.email);
        },
        showModalSignatureOptions(option) {
            const SIGNATURE_OPTIONS = {
                1: () => { this.showModalSignatureBio() },
                2: () => { this.showModalOTP() },
                3: () => { this.openDigitalCertificate() },
                4: () => { this.$bvModal.show("signatureOptions") }
            }

            SIGNATURE_OPTIONS[option]();
        },
        showModalSignatureBio() {
            this.$bvModal.hide('signatureOptions');
            this.createCameraElement();
            this.$bvModal.show('signatureBio');
            if (this.VerifySignerOption) {
                this.startHuman();
            } else {
                this.isValidFace = true;
            }
        },
        onCanceleSignatureBio() {
            this.stopCameraStream();
            this.$bvModal.hide('signatureBio');
        },
        showModalOTP() {
            this.$bvModal.hide('signatureOptions');
            this.$bvModal.show('signatureOTP');
        },
        openDigitalCertificate() {
            alert("No disponible temporalmente.");
        },
        askData() {
            console.log("click en el aceptar dañado")
            this.$bvModal.hide('document-pending-modal');
            if (this.ask_data) {
                this.$bvModal.show('data-pending-modal');
            }
        },
        saveAskedData() {
            var data = JSON.stringify({
                documentId: this.askedUserData.documentId,
                name: this.askedUserData.name,
                lastName: this.askedUserData.lastName,
                email: this.$route.params.email
            });

            var config = {
                method: "post",
                url: "/api/File/SaveExternalUserAskedData",
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                },
                data: data,
            };
            this.isLoading = true;
            this.$bvModal.hide('data-pending-modal');
            axios(config)
                .then(async (response) => {
                    this.isLoading = false;
                    if (response.data != null) {
                        console.log(response.data);
                    }
                });
        },
        saveRejectDocument() {
            var data = JSON.stringify({
                fileid: this.pdf_id,
                email: this.email,
                details: this.rejectDocumentDetails
            });

            var config = {
                method: "post",
                url: "/api/File/SaveRejectedDocument",
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                },
                data: data,
            };
            this.isLoading = true;
            this.$bvModal.hide('reject-document-modal');
            axios(config)
                .then(async (response) => {
                    this.isLoading = false;
                    if (response.data != null) {
                        this.show_sign = false;
                        this.sign_button = false;
                        this.sign_button = false;
                    }
                    this.$router.push({
                        name: 'view-signed', params: {
                            id: this.$route.params.id
                        }
                    })
                });
        },
        saveSign() {
            let speakMessage = "Firma agregada correctamente al documento, dar click a \"Aceptar\" para previsualizar la misma.";
            this.show_sign = true;
            this.image = true;
            this.takePhoto();
            //check when upload sign
            if (this.image_captured.length > 0) {
                setTimeout(() => {
                    this.$bvModal.hide('signatureBio');
                    const data = this.$refs.signaturePad.saveSignature();
                    this.signaturePad = data.data;

                    this.img = data.data;
                    this.addSignatureToPage();

                    //check images catured is complete in case of camera off
                    if (this.image_captured.length < 3) {
                        this.takePhoto();
                    }

                    this.stopCameraStream();
                    this.playAudio(speakMessage);
                    this.$bvModal.show('generated-signature-modal');

                }, 800);
            }

        },
        addSignatureToPage() {
            if (this.fillSignaturePositionsWithServerValues) {
                let canvas = this.$refs.pdfComponent.getElementsByTagName("canvas")[0];
                let canvasWidth = canvas.getBoundingClientRect().width;
                let canvasHeight = canvas.getBoundingClientRect().height;
                this.userFileSignaturePositions.forEach((item) => {

                    const signatureDataForServer = this.buildSignatureData(item.ImageWidth, item.ImageHeight, item.PositionX, item.PositionY, false, false, item.PageWidth, item.PageHeight);
                    let x = 0; let y = 0;

                    x = Math.round((item.PositionX * canvasWidth) / item.PageWidth);
                    y = Math.round((item.PositionY * canvasHeight) / item.PageHeight);


                    item.ImageWidth = Math.round((item.ImageWidth * canvasWidth) / item.PageWidth);
                    item.ImageHeight = Math.round((item.ImageHeight * canvasHeight) / item.PageHeight);


                    const signatureDataForShow = this.buildSignatureData(item.ImageWidth, item.ImageHeight, x, y, false, false, item.PageWidth, item.PageHeight);

                    const currentPage = item.PageNumber - 1;
                    this.pagesSignatures[currentPage].signatures.push(signatureDataForServer);
                    this.pagesSignatures[currentPage].signaturesForShow.push(signatureDataForShow);
                });
            } else {
                const currentPage = this.page - 1;
                const pageObject = this.pagesSignatures[currentPage];
                const signatureData = this.buildSignatureData(100, 100, 0, 0, true, true, pageObject.pageWidth, pageObject.pageHeight);
                pageObject.signatures.push(signatureData);
                pageObject.signaturesForShow = pageObject.signatures;
            }
        },
        buildSignatureData(width, height, xPos, yPos, draggable, resize, pageWidth, pageHeight) {
            const signatureData = {
                id: this.incrementalSignatureId++,
                img: this.img,
                imageWidth: width,
                imageHeight: height,
                xPosition: xPos,
                yPosition: yPos,
                draggable: draggable,
                resize: resize,
                pageWidth: pageWidth,
                pageHeight: pageHeight,
                onResize: function (x, y, width, height) {
                    this.xPosition = x;
                    this.yPosition = y;
                    this.imageWidth = width;
                    this.imageHeight = height;
                },
                onDrag: function (x, y) {
                    this.xPosition = x
                    this.yPosition = y
                },
            };
            return signatureData;
        },
        undoSign() {
            this.$refs.signaturePad.undoSignature();
        },
        saveLocation() {

            let speakMessage = "Firmando documento..";

            this.finishLoading = true;
            this.signatureStyleObject.opacity = 0.1;

            let formData = new FormData();
            // id File
            formData.append('FileId', this.$route.params.id);
            //user email
            formData.append('Email', this.email);
            //sign image
            formData.append('image', this.img);
            //captured image
            if (this.image_captured.length > 0) {
                this.image_captured.forEach(file => {
                    formData.append('clientImage', file);
                });
            }

            for (let i = 0; i < this.pagesSignatures.length; i++) {
                let pageObject = this.pagesSignatures[i];
                for (let j = 0; j < pageObject.signatures.length; j++) {
                    let signatureObject = pageObject.signatures[j];
                    formData.append('Pages[]', pageObject.pageNumber);
                    formData.append('pageWidth[]', signatureObject.pageWidth);
                    formData.append('pageHeight[]', signatureObject.pageHeight);
                    formData.append('ImageWidths[]', signatureObject.imageWidth);
                    formData.append('ImageHeights[]', signatureObject.imageHeight);
                    formData.append('XPositions[]', signatureObject.xPosition);
                    formData.append('YPositions[]', signatureObject.yPosition);
                }
            }

            axios.post('/api/File/sign-document', formData).then(response => {
                this.playAudio(speakMessage);
                this.finishLoading = false;
                this.signatureStyleObject.opacity = 0.85;
                //this.$refs.draggy.style.opacity = 0.85;

                if (response.data.IsSuccessFul == true) {
                    this.recipient_name = response.data.Result.Name;
                    this.recipient_email = response.data.Result.SendTo;
                    this.playAudio("Documento firmado correctamente, Gracias por firmar con ConfidenceID");
                    this.$bvModal.show('save-signature-modal');
                } else {
                    this.$bvToast.toast(response.data.Result, {
                        title: 'Lo sentimos',
                        variant: 'danger'
                    });
                    return;
                }
            });

        },
        sendReminder(index) {
            this.reminderLoading = true;
            axios.get('/api/File/SendNotification/' + this.pdf_id + '/' + this.senders[index].Name + '/' + this.senders[index].SendTo).then(response => {
                this.reminderLoading = false;
                if (response.data.IsSuccessFul) {
                    this.$bvToast.toast(`Ha enviado el correo de recordatorio de firma correctamente.`, {
                        title: 'Enhorabuena',
                        variant: 'info'
                    });
                }
            });
        },
        createCameraElement() {
            if (navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({ video: true })
                    .then(stream => {
                        this.$refs.camera.srcObject = stream;
                    })
                    .catch(() => {
                        alert("Puede que la webcam este bloqueada en el navegador");
                    });
            }
        },
        async onPlay() {
            console.log("playing");
        },
        startHuman() {
            const humanConfig = { // user configuration for human, used to fine-tune behavior
                cacheSensitivity: 0,
                modelBasePath: 'https://cdn.jsdelivr.net/npm/@vladmandic/human/models',
                async: true,
                filter: { enabled: true, equalization: false }, // lets run with histogram equilizer
                debug: false,
                face: {
                    enabled: true,
                    detector: { rotation: true, return: true, mask: false }, // return tensor is used to get detected face image
                    description: { enabled: true }, // default model for face descriptor extraction is faceres
                    // mobilefacenet: { enabled: true, modelPath: 'https://vladmandic.github.io/human-models/models/mobilefacenet.json' }, // alternative model
                    // insightface: { enabled: true, modelPath: 'https://vladmandic.github.io/insightface/models/insightface-mobilenet-swish.json' }, // alternative model
                    iris: { enabled: true }, // needed to determine gaze direction
                    emotion: { enabled: false }, // not needed
                    //  antispoof: { enabled: true }, // enable optional antispoof module
                    // liveness: { enabled: true }, // enable optional liveness module
                },
                body: { enabled: false },
                hand: { enabled: false },
                object: { enabled: false },
                gesture: { enabled: true }, // parses face and iris gestures
            };

            this.canvas = document.getElementById("canv");
            this.video = document.getElementById("video");

            this.human = new Human(humanConfig);

            this.humanConfig = humanConfig;

            const timestamp = { detect: 0, draw: 0, tensors: 0, start: 0 }; // holds information used to calculate performance and possible memory leaks
            const fps = { detectFPS: 0, drawFPS: 0, frames: 0, averageMs: 0 }; // holds calculated fps information for both detect and screen refresh
            this.timestamp = timestamp;
            this.fps = fps;
            this.detectionGestures = ["none"];
            this.playAudio("Espere un momento por favor cargando sistema...");
            this.main();
        },
        async main() {
            // main entry point
            this.loading = true;
            console.log("loading...");
            if (this.isValidFace != true) {
                this.human.load().then(() => {
                    this.startDetection();
                });
            }
        },
        startDetection() {
            this.intervalTimer = setInterval(this.checkLiveness.bind(this), 1000);
            this.drawTimer = setInterval(this.draw.bind(this), 100);
        },
        checkLiveness() {
            if (this.isGreen) {
                this.playAudio("Sistema listo para detectar rostros...");
                this.isGreen = true;
                console.log("checking...");
                clearInterval(this.intervalTimer);
                this.action = "CIERRE Y ABRA LOS OJOS EN LOS PRÓXIMOS 5 SEGUNDOS";
                this.playAudio("CIERRE Y ABRA LOS OJOS EN LOS PRÓXIMOS 5 SEGUNDOS");
                this.step1Validation();
            }
        },
        async playAudio(message) {
            speakMessage(message, this.allowSpeech);
        },
        draw() {

            const width = document.getElementById("video").videoWidth;
            const height = document.getElementById("video").videoHeight;

            this.canvas = document.getElementById("canv");

            this.canvas.width = width;
            this.canvas.height = height;

            this.drawOval(this.circleColor);

            this.human.detect(this.video).then((result) => {
                this.face = result.face[0];

                if (this.face) {
                    const x = this.face.box[0];
                    const y = this.face.box[1];
                    const w = this.face.box[2];
                    const h = this.face.box[3];
                    const centerX = x + w / 2;
                    const centerY = y + h / 2;
                    const radius = Math.min(w, h) / 2;
                    const videoWidth = this.video.videoWidth;
                    const videoHeight = this.video.videoHeight;
                    const circleCenterX = videoWidth / 2;
                    const circleCenterY = videoHeight / 2;
                    const distanceToCenter = Math.sqrt(
                        (centerX - circleCenterX) ** 2 + (centerY - circleCenterY) ** 2
                    );

                    if (distanceToCenter <= radius) {
                        this.isInsideCircle = true;
                    } else {
                        this.isInsideCircle = false;
                    }

                    // check if face is inside circle
                    if (this.isInsideCircle) {
                        this.greenTimer += 100;
                        // check if enough time has passed inside the circle
                        if (this.greenTimer >= 2000) {
                            this.circleColor = "#00FF00";
                            this.isGreen = true;
                            let gestures = Object.values(result.gesture).map(
                                (gesture) => gesture.gesture
                            ); // flatten all gestures
                            for (var i = 0; i < gestures.length; i++) {
                                this.detectionGestures.push(gestures[i]);
                            }
                        } else {
                            this.action = "Manténgase quieto con el rostro dentro del círculo";
                            this.circleColor = "#FF0000";
                            this.isGreen = false;

                            this.detectionGestures = ["none"];
                        }
                    } else {
                        this.action = "Coloque su rostro dentro del círculo";
                        this.greenTimer = 0;
                        this.circleColor = "#FF0000";
                        this.isGreen = false;
                    }
                } else {
                    this.message = "No se ha detectado un rostro";
                    this.greenTimer = 0;
                    this.circleColor = "#FF0000";
                    this.action = "Coloque su rostro dentro del círculo";
                    this.isGreen = false;
                }
            });
        },
        drawOval(color) {
            let canvas = document.getElementById("canv");
            this.video = document.getElementById("video");
            var ctx = canvas.getContext("2d");
            let width = canvas.width;
            let height = canvas.height;
            ctx.beginPath();
            if (window.screen.width < 768) {
                ctx.ellipse(
                    this.video.videoWidth / 2,
                    this.video.videoHeight / 2,
                    210,
                    210,
                    0,
                    0,
                    2 * Math.PI
                );
            } else {
                ctx.ellipse(
                    this.video.videoWidth / 2,
                    this.video.videoHeight / 2,
                    this.video.videoWidth / 4,
                    this.video.videoWidth / 4,
                    0,
                    0,
                    2 * Math.PI
                );
            }
            ctx.lineWidth = 3;
            ctx.setLineDash([5, 3]);
            ctx.strokeStyle = color;
            ctx.stroke();
            ctx.rect(0, 0, width, height);
            ctx.fillStyle = "rgba(220, 220, 220, 0.8)";
            ctx.fill("evenodd");
        },
        async detectionLoop() {
            // main detection loop

            const video = document.getElementById("video");

            if (video != null && !video.paused) {
                if (this.timestamp.start === 0) this.timestamp.start = this.human.now();
                await this.human.detect(video); // actual detection; were not capturing output in a local variable as it can also be reached via human.result
                const tensors = this.human.tf.memory().numTensors; // check current tensor usage for memory leaks
                if (tensors - this.timestamp.tensors !== 0)
                    this.timestamp.tensors = tensors;
                this.fps.detectFPS =
                    Math.round(
                        (1000 * 1000) / (this.human.now() - this.timestamp.detect)
                    ) / 1000;
                this.fps.frames++;
                this.fps.averageMs =
                    Math.round(
                        (1000 * (this.human.now() - this.timestamp.start)) / this.fps.frames
                    ) / 1000;
                if (this.fps.frames % 100 === 0 && !video.paused)
                    console.log("performance", {
                        ...this.fps,
                        tensors: this.timestamp.tensors,
                    });
            }

            this.timestamp.detect = this.human.now();
            requestAnimationFrame(this.detectionLoop); // start new frame immediately
        },
        async drawLoop() {
            // main screen refresh loop
            this.loading = false;
            const video = document.getElementById("video");
            const canvas = document.getElementById("canv");

            if (video != null && !video.paused) {


                let gestures = Object.values(this.human.result.gesture).map(
                    (gesture) => gesture.gesture
                ); // flatten all gestures
                for (var i = 0; i < gestures.length; i++) {
                    this.detectionGestures.push(gestures[i]);
                }

                const interpolated = this.human.next(this.human.result); // smoothen result using last-known results
                const processed = await this.human.image(video); // get current video frame, but enhanced with human.filters
                this.human.draw.canvas(processed.canvas, canvas);
                const opt = {
                    drawBoxes: true,
                    color: "blue",
                    drawLabels: false,
                    drawPoints: false,
                    drawAttention: false,
                    drawGestures: false,
                    drawGaze: false,
                    fillPolygons: false,
                    useCurves: false,
                    drawPolygons: false,
                };
                await this.human.draw.face(canvas, interpolated.face, opt); // draw labels, boxes, lines, etc.
                //   perf(interpolated.performance); // write performance data

                const now = this.human.now();
                this.fps.drawFPS =
                    Math.round((1000 * 1000) / (now - this.timestamp.draw)) / 1000;
                this.timestamp.draw = now;

                setTimeout(this.drawLoop, 100); // use to slow down refresh from max refresh rate to target of 30 fps
            }
        },
        async step1Validation() {
            setTimeout(async () => {
                if (this.face) {
                    if (!this.isGreen) {
                        this.startDetection();
                    }
                    else {
                        if (
                            this.detectionGestures.includes("blink left eye") &&
                            this.detectionGestures.includes("blink right eye")
                        ) {
                            // gest++;
                            this.validFace();
                            clearInterval(this.drawTimer);
                            clearInterval(this.intervalTimer);
                            //this.step2Validation();
                        }
                        else {
                            clearInterval(this.drawTimer);
                            clearInterval(this.intervalTimer);
                            this.action = "NO HA CUMPLIDO LA VALIDACIÓN, INTENTE FIRMAR NUEVAMENTE";
                            this.neutral_step = false;
                            this.smile_step = false;
                            this.startHuman();
                            this.attemps++;
                            this.tryAgainOption = true;
                            if (3 - this.attemps == 0) {
                                this.action =
                                    "Ha realizado los 3 intentos de validación disponibles, por favor intente en otro momento";
                                this.tryAgainOption = false;
                            }
                            this.isShotPhoto = true;
                        }
                    }
                } else {
                    this.action = "NO SE DETECTA UNA PERSONA";
                    this.neutral_step = false;
                    this.smile_step = false;
                    this.attemps++;
                    this.tryAgainOption = true;
                    if (3 - this.attemps == 0) {
                        this.action = "Ha realizado los 3 intentos de validación disponibles, por favor intente en otro momento";
                        this.tryAgainOption = false;
                    }
                    this.isShotPhoto = true;
                }
            }, 5000);
        },
        validFace() {
            //this.capture();
            this.action = "FIRMA PERMITIDA";
            this.smile_step = true;
            this.isValidFace = true;
            this.neutral_step = false;
            this.smile_step = false;
        },
        isCedula() {
            let pattern = /^(PE|E|N|[23456789](?:AV|PI)?|1[0123]?(?:AV|PI)?)-(\d{1,4})-(\d{1,7})$/i;
            return (this.cedula.match(pattern)) ? true : false;
        },
        async capture() {
            if (this.isCedula() == false) {
                this.action = "FIRMA PERMITIDA";
                this.smile_step = true;
                this.isValidFace = true;
                this.neutral_step = false;
                this.smile_step = false;
                return;
            }

            const canvas = this.$refs.canvas;
            const context = canvas.getContext('2d');
            canvas.width = this.$refs.camera.videoWidth;
            canvas.height = this.$refs.camera.videoHeight;
            context.drawImage(this.$refs.camera, 0, 0, canvas.width, canvas.height);
            const image = canvas.toDataURL("image/png");
            if (image.length > 5000) {
                console.log("taked!!");
            } else {
                this.$bvToast.toast(`Su webcam debe estar desactivada.`, {
                    title: 'Por favor revise:',
                    variant: 'danger'
                });
                this.undoSign();
            }
            let data = JSON.stringify({
                documentId: this.cedula,
                userImage: image
            });
            let config = {
                method: "post",
                url: "https://bio-te-api.azurewebsites.net/api/Biometric/validate-faceid",
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                },
                data: data,
            };
            this.ValidateTELoading = true;
            await axios(config)
                .then(async (response) => {
                    this.ValidateTELoading = false;
                    if (response.data != null) {
                        if (
                            response.data.resultado != 0 || this.cedula == "k250663"
                        ) {
                            this.action = "FIRMA PERMITIDA";
                            this.smile_step = true;
                            this.isValidFace = true;
                            this.neutral_step = false;
                            this.smile_step = false;
                        } else {
                            this.$bvToast.toast(`No ha cumplido con la validación y no puede firmar el documento en este momento`, {
                                title: 'Error:',
                                variant: 'danger'
                            });
                            setTimeout(() => {
                                this.action = "POR FAVOR MIRE EN DIRECCIÓN A LA CAMARA Y SIGA LAS INSTRUCCIONES";
                                this.$bvModal.hide('signatureBio');
                                this.stopCameraStream();
                            }, 2000);
                            if (response.data.infoTipo == null) {
                                this.$bvToast.toast(`La validación biométrica no se encuentra disponible. Intente nuevamete en otro momento. Gracias`, {
                                    title: 'Error:',
                                    variant: 'danger'
                                });
                            }
                        }
                    } else {
                        this.error =
                            "La validación biométrica no se encuentra disponible. Intente nuevamete en otro momento. Gracias";
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    this.ValidateTELoading = false;
                });
            this.ValidateTELoading = false;
        },
        takePhoto() {
            const canvas = this.$refs.canvas;
            const context = canvas.getContext('2d');
            canvas.width = this.$refs.camera.videoWidth;
            canvas.height = this.$refs.camera.videoHeight;
            context.drawImage(this.$refs.camera, 0, 0, canvas.width, canvas.height);
            const image = canvas.toDataURL("image/jpeg");
            if (image.length > 5000) {
                this.image_captured.push(image);
            } else {
                this.$bvToast.toast(`Su webcam debe estar desactivada.`, {
                    title: 'Por favor revise:',
                    variant: 'danger'
                });
                this.undoSign();
            }
        },
        stopCameraStream() {
            let tracks = this.$refs.camera.srcObject.getTracks();
            tracks.forEach(track => {
                track.stop();
            });
        },
        getEvidencias(selected) {
            if (selected === "") {
                this.evidenceLoading = false;
                return;
            }
            this.evidenceLoading = true;
            this.userEmailSign = selected;
            axios.get('/api/File/GetSignatureDetail/' + this.pdf_id + '/' + selected).then(response => {
                this.userSent = response.data.Result.UserSent;
                this.userSign = response.data.Result.UserSign;
                this.sentDate = response.data.Result.DateSent;
                this.signDate = (response.data.Result.DateSign !== '0001-01-01T00:00:00')
                    ? this.formatDate(response.data.Result.DateSign)
                    : "No firmado";
                this.user_captured = response.data.Result.ClientImage;
                this.dateReception = response.data.Result.DateReception;
                this.evidenceLoading = false;
            });
        },
        formatDate(date) {
            const options = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            };

            const formattedDate = new Intl.DateTimeFormat('es-ES', options).format(new Date(date));
            return formattedDate;
        },
        onDocumentList() {
            this.$router.push({ name: 'list' });
        },
        onSaveSignature() {
            this.$bvModal.hide('save-signature-modal');
            if (this.$store.getters.loggedIn)
                this.$router.push({ name: 'list', params: { state: 'Completado' } });
            else
                this.$router.go(0);
        },
        pdfLoaded() {
            console.log('loaded');
            this.page = 1;
        },
        error: function (err) {

            console.log(err);
        },
        isPhone() {
            const ua = navigator.userAgent;

            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                return true;
            } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                return true;
            }
            return false;
        },
        sendOTP() {
            axios.post('/api/File/SendOTPCode?id=' + this.pdf_id).then(response => {
                if (response.data.Result == "OK") {
                    this.$bvModal.show('sendOTP-success-modal');
                } else {

                    if (response.data.Result == "no phone number") {
                        this.$bvToast.toast(`Por favor, accede con tus credenciales para poder utilizar esta función.`, {
                            title: 'Lo sentimos',
                            variant: 'danger'
                        });
                    }
                    else {

                        this.$bvToast.toast(`Ha ocurrido un error al enviar el código OTP`, {
                            title: 'Lo sentimos',
                            variant: 'danger'
                        });
                    }
                }

            }).catch(function () {
                this.$bvToast.toast(`Ha ocurrido un error al enviar el código OTP`, {
                    title: 'Lo sentimos',
                    variant: 'danger'
                });
            });
        },
        verifyOTP(buttonVerify) {

            buttonVerify.target.setAttribute("disabled", "disabled");
            axios.get('/api/File/VerifyOTPCode/' + this.pdf_id + "/" + this.codeOTP).then(response => {

                if (response.data == "OK") {

                    this.$bvModal.hide('signatureOTP');

                    this.img = true;
                    this.show_sign = true;
                    this.$bvModal.show('save-signature-modal');

                } else {
                    this.$bvToast.toast(`El código OTP no ha podido ser verificado.`, {
                        title: 'Lo sentimos',
                        variant: 'danger'
                    });
                }
            }).catch(() => {
                this.$bvToast.toast(`El código OTP no ha podido ser verificado.`, {
                    title: 'Lo sentimos',
                    variant: 'danger'
                });
                buttonVerify.target.removeAttribute("disabled", "disabled");
            });
        },
        onSendOtpCode() {
            this.$bvModal.hide('sendOTP-success-modal');
        },
        backToList() {
            this.$router.push({ name: 'list' });
        },
        watchRenderPage() {
            let canvas = this.$refs.pdfComponent.getElementsByTagName('canvas')[0];
            setTimeout(() => {

                let width = getComputedStyle(canvas).width;
                let height = getComputedStyle(canvas).height;

                width = parseFloat(width);
                height = parseFloat(height);

                this.pageWidth = width;
                this.pageHeight = height;
                let pageObject = this.pagesSignatures[this.page - 1];

                pageObject.pageWidth = width;
                pageObject.pageHeight = height;

                this.allowSignatures = true; // race condition
            }, 2000);
        },
        getSpeaker(bool) {
            this.allowSpeech = bool;
        },
    }
}
</script>

<style scoped>
.viewer {
    position: relative;
    width: 100%;
}

.pg_number {
    position: absolute;
    width: 100%;
    top: 5px;
    z-index: 20;
    text-align: center;
}

.arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.arrow:hover {
    cursor: pointer;
}

.arrow.left {
    left: 5px;
    z-index: 20;
}

.arrow.right {
    right: 5px;
    z-index: 20;
}

.info-t {
    font-size: clamp(0.5625rem, 0.4063rem + 0.625vw, 0.875rem);
    color: #2B2B2F;
    font-weight: 700;
}

.info-d {
    position: relative;
    padding: 2px 4px;
    background-color: #ebebec;
    border-radius: 2px;
    font-size: clamp(0.5625rem, 0.4688rem + 0.375vw, 0.75rem);
    font-weight: 500;
}

.signButtonGrid {
    display: grid;
    grid-row-gap: 10px;
}


.pdf-container {
    background-color: #BAC2C4;
    margin: 0.5rem;
}

.pdf-component {
    padding: 1rem;
    background-color: #BAC2C4;
}

.info-box-rounded.doc-info {
    background-color: #385ca31a !important;
    min-height: 25px !important;
}

.doc-info-subtitle {
    font-size: 14px;
    margin-left: 0.5rem;
}

#signaturePad {
    border: 2px solid #94939761;
    background-image: radial-gradient(#a4a4a452 20%, transparent 20%), radial-gradient(#FAFAFA 20%, transparent 20%);
    background-color: #ffffff;
    background-position: 0 0, 50px 50px;
    background-size: 8px 8px;
    margin-top: 0.8rem;
    border-radius: 8px;
}

.certificate {
    margin-top: 1rem !important;
    height: unset !important;
}

.vdr {
    cursor: move;
    border: unset !important;
}

.btn .b-icon.bi {
    margin-right: 5px;
    font-size: 1.5rem;
}

#current_page {
    width: 40px;
    margin-left: 3px;
    padding: 0;
    margin-right: 2px;
    text-align: center;
    border: 0.5px solid grey;
}

#canv {
    object-fit: contain;
    position: absolute;
    background-color: transparent;
    max-width: 100%;
    width: 100%;
    width: var(--width);
    height: calc(var(--width) * 0.75);
    border-radius: 5px;
}

.webcam-container {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
}

video {
    background: #222;
    --width: 100%;
    width: var(--width);
    border-radius: 5px;
}

.details-col {
    background: #fff;
    position: fixed;
    overflow-y: auto;
    width: 21%;
}

.marginButton {
    margin-top: 3rem;
}

/*stepper*/
.wizard-icon-circle {
    width: 30px !important;
    height: 30px !important;
    font-size: 15px !important;
}

li.active .wizard-icon-circle {
    background-color: #2E344A !important;
}

.wizard-progress-with-circle {
    top: 20px !important;
    margin-left: 5px !important;
}

li.active #step-Enviodeldocumento0,
li.active #step-Recepciondeldocumento1,
li.active #step-Firmadeldocumento2 {
    background: #E92135;
}

.img-thumbnail {
    border-radius: unset !important;
    background-color: #dee2e6 !important;
}

::v-deep .vue-form-wizard .wizard-header {
    padding: unset !important;
}

::v-deep .vue-form-wizard .wizard-tab-content {
    padding: 20px 0;
}

::v-deep .vue-form-wizard .wizard-card-footer {
    padding: unset !important;
    margin-top: 1rem !important;
}

::v-deep .vue-form-wizard.sm .wizard-nav-pills>li.active>a .wizard-icon {
    font-size: 15px;
}

::v-deep .stepTitle {
    font-size: 11px !important;
    padding-top: 0.5rem !important;
    font-weight: 700 !important;
}

.wizard-circle-btn {
    border-radius: 50% !important;
    background-color: #E92135;
    color: #fff;
    border: #E92135;
    width: 30px;
    height: 30px;
}

.sign-image {
    width: 65%;
}

@media only screen and (max-width: 765px) {
    .custom_button_wizard {
        margin-bottom: 2rem;
    }

    .vue-form-wizard .wizard-btn {
        min-width: unset;
    }

    .pdf-container {
        margin: unset;
    }

    .pdf-self {
        width: 100%;
        margin: 0;
        border: 1px solid #8080804f;
    }

    .sign-image {
        width: 28%;
    }
}

/*responsive*/
@media (min-width:768px) and (max-width: 992px) {
    .sign-image {
        width: 30%;
    }
}

@media only screen and (max-width: 1024px) {
    .marginButton {
        margin-top: 0 !important;
    }
}
</style>